import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface SmsDetailsData {
  smsTrackingId: number;
  createdAt: string;
  smsType: string;
  sendTo: string;
  sendby: string;
  description: string;
  status: number;
  response: string;
}

@Component({
  selector: 'app-sms-details-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './sms-details-dialog.component.html',
  styleUrls: ['./sms-details-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SmsDetailsDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SmsDetailsData,
    public dialogRef: MatDialogRef<SmsDetailsDialogComponent>
  ) {}

  formatDateTime(dateString: string): string {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  getStatusText(): string {
    return this.data.status === 200 ? 'Sent' : `Failed`;
  }

  getResponseMessage(): string {
    if (this.data.status === 200) {
      return 'SMS sent successfully.';
    }
    return this.data.response || 'N/A';
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
